import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-ink-900" data-id="element-173" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "17px",
      paddingBottom: "12px"
    }} data-id="element-174" data-mp="3fyvy6aic1db3">
        <h2 id="testimonios" className="text-center font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-175" data-mp="3azj9dk7whw5v">
          Lo que dicen los coaches que ya lo usan
        </h2>

        <ul className="mt-10 grid gap-6 lg:grid-cols-3" data-id="element-176" data-mp="31zd3okig20h9">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl border border-ink-600 bg-ink-800 p-6" data-id="element-177" data-mp="2x0jmah01dpbt">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-178" data-mp="2s2i5y3tzw441">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-ball-400 text-ball-400" aria-hidden="true" data-id="element-179" data-mp="v8ndhf596tkq" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 text-[15px] leading-relaxed text-slate-200" data-id="element-180" data-mp="q8irj9lkt6n4">
                “{testimonial.quote}”
              </blockquote>
              <footer className="mt-auto pt-6 text-sm font-semibold text-court-200" data-id="element-181" data-mp="m5sysg0nlynm">
                {testimonial.name} <span className="text-slate-500" data-id="element-182" data-mp="79258ndnvh5x">— {testimonial.country}</span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}